<div class="transformer-container">
    <header class="d-flex justify-content-between align-items-center">
        <h4>{{equipment.className}}</h4>
        <button *ngIf="permissionsService.isNetworkStructureCreateEditAllowed"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#propertyModal"
        >
        Add Property
        </button>
    </header>
    <div class="transformer-form">
        <div class="name-voltage">
            <div class="name row mb-4">
                <span class="col-6">Class Generic Name</span>
                <div class="col-6 px-2">
                    <input [disabled]="!editEnabled" class="w-100" [(ngModel)]="equipment.className" (ngModelChange)="notifySchematicDiagram()" type="text" placeholder="Title"/>
                </div>
            </div>
            <div class="voltage row">
                <span class="col-6">Voltage</span>
                <lib-enum-dropdown 
                    class="px-2 col-3" 
                    (valueChange)="onSelectPrimaryVoltage($event)" 
                    [initialValue]="equipment.primaryVoltage ? Voltage[equipment.primaryVoltage] : null"
                    [enumObject]="Voltage" [isLabelled]="true" 
                    [label]="'Primary'"
                    [disabled]="!editEnabled"
                ></lib-enum-dropdown>
                <lib-enum-dropdown 
                    class="px-2 col-3" 
                    (valueChange)="onSelectSecondaryVoltage($event)" 
                    [initialValue]="equipment.secondaryVoltage ? Voltage[equipment.secondaryVoltage] : null"
                    [enumObject]="Voltage" 
                    [isLabelled]="true" 
                    [label]="'Sec.'"
                    [disabled]="!editEnabled"
                ></lib-enum-dropdown>
            </div>
        </div>
        <div class="connectivity">
            <div class="row mb-4">
                <span class="col-6">Transformer Winding (Primary Side)</span>
                <lib-object-dropdown
                    class="col-4"
                    (multiValueChange)="onSelectConnectivitySource($event!)"
                    [items]="connectivitySourceOptions"
                    [displayField]="'className'" 
                    [initialValue]="connectivitySourceInitialValue"
                    [disabled]="!editEnabled"
                    [isMultiSelect]="true"
                    [trackByField]="'id'"
                ></lib-object-dropdown>
                <div class="col-2 readonly-container">
                    <span class="label">V</span>
                    <span class="value">
                        {{ equipment.primaryVoltage ? Voltage[+equipment.primaryVoltage] || equipment.primaryVoltage : '' }}
                    </span>
                </div>
            </div>
            <div class="row">
                <span class="col-6">AC Line Type</span>
                <div class="col-6 px-2 readonly-container field">
                    <span class="value">Incomer</span>
                </div>
            </div>
        </div>
        <div class="secondary-side">
            <div class="row mb-4">
                <span class="col-6">Transformer Winding (Secondary Side)</span>
                <lib-object-dropdown
                    class="col-4 px-2"
                    (multiValueChange)="onSelectConnectivityDestination($event!)"
                    [items]="connectivityDestinationOptions"
                    [displayField]="'className'" 
                    [initialValue]="connectivityDestinationInitialValue"
                    [disabled]="!editEnabled"
                    [isRequired]="true"
                    [isMultiSelect]="true"
                    [trackByField]="'id'"
                ></lib-object-dropdown>
                
                <div class="col-2 readonly-container">
                    <span class="label">V</span>
                    <span class="value">
                        {{ equipment.secondaryVoltage ? Voltage[+equipment.secondaryVoltage] || equipment.secondaryVoltage : '' }}
                    </span>
                </div>
            </div>
            <div class="row">
                <span class="col-6">AC Line Type</span>
                <div class="col-6 px-2 readonly-container field">
                    <span class="value">Outgoing</span>
                </div>
            </div>
        </div>
        <div class="symbol-color">
            <lib-icon-color [disabled]="!editEnabled" [equipment]="equipment" (iconChanged)="notifySchematicDiagram()"></lib-icon-color>
        </div>
        <div *ngIf="permissionsService.isNetworkStructureCreateEditAllowed" class="buttons-container py-3 px-4 d-flex justify-content-end gx-3">
            <button class="cancel">Cancel</button>
            <button [class.disabled]="!editEnabled" [disabled]="!editEnabled" class="save" (click)="onSave()">Save</button>
        </div>
    </div>
</div>

 <div
  class="modal fade"
  id="propertyModal"
  tabindex="-1"
  aria-labelledby="propertyModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered modal-add-property">
    <div class="modal-content">
      <div class="modal-header p-4 mt-0">
        <div id="propertyModalLabel">
          Add Property
        </div>
      </div>

      <div
        class="modal-body d-flex justify-content-center align-items-center gap-3 modal-body-add-property"
      >
        <div class="add-property-row">
            <label class="add-property-label">Property Type</label>
            <lib-enum-dropdown style="width: 60%; height: 36px;" (valueChange)="onSelectPrimaryVoltage($event)" [enumObject]="PropertyType"></lib-enum-dropdown>
        </div>
        <div class="add-property-row">
            <label class="add-property-label">Property Name</label>
            <div class="add-property-value">
                <input placeholder="Title"/>
            </div>      
        </div>
        <div class="add-property-row">
            <label class="add-property-label">Min Characters</label>
            <div class="add-property-value">
                <input type="text" placeholder="0"/>
                <div style="display: flex;">
                    <button class="minut__btn">
                        <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 4.75C0.75 4.336 1.086 4 1.5 4H9.5C9.914 4 10.25 4.336 10.25 4.75C10.25 5.164 9.914 5.5 9.5 5.5H1.5C1.086 5.5 0.75 5.164 0.75 4.75Z" fill="#171717" fill-opacity="0.6"/>
                        </svg>
                    </button>
                    <button class="plus__btn">
                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.74922 0.999219C4.74922 0.599219 5.04922 0.199219 5.54922 0.199219C5.94922 0.199219 6.24922 0.599219 6.24922 0.999219V4.49922H9.74922C10.1492 4.49922 10.5492 4.79922 10.5492 5.29922C10.5492 5.69922 10.1492 5.99922 9.74922 5.99922H6.24922V9.49922C6.24922 9.89922 5.94922 10.2992 5.44922 10.2992C5.25482 10.2747 5.07616 10.1798 4.94713 10.0323C4.81811 9.88484 4.74768 9.69515 4.74922 9.49922V5.99922H1.24922C1.03705 5.99922 0.833562 5.91493 0.683533 5.7649C0.533504 5.61488 0.449219 5.41139 0.449219 5.19922C0.449219 4.79922 0.849219 4.49922 1.24922 4.49922H4.74922V0.999219Z" fill="#171717" fill-opacity="0.6"/>
                        </svg>
                    </button>
                </div>
                <button>Clear</button>
            </div>  
        </div>
        <div class="add-property-row">
            <label class="add-property-label">Max Characters</label>
             <div class="add-property-value">
                <input type="text" placeholder="0"/>
                <div style="display: flex;">
                    <button class="minut__btn">
                        <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 4.75C0.75 4.336 1.086 4 1.5 4H9.5C9.914 4 10.25 4.336 10.25 4.75C10.25 5.164 9.914 5.5 9.5 5.5H1.5C1.086 5.5 0.75 5.164 0.75 4.75Z" fill="#171717" fill-opacity="0.6"/>
                        </svg>
                    </button>
                    <button class="plus__btn">
                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.74922 0.999219C4.74922 0.599219 5.04922 0.199219 5.54922 0.199219C5.94922 0.199219 6.24922 0.599219 6.24922 0.999219V4.49922H9.74922C10.1492 4.49922 10.5492 4.79922 10.5492 5.29922C10.5492 5.69922 10.1492 5.99922 9.74922 5.99922H6.24922V9.49922C6.24922 9.89922 5.94922 10.2992 5.44922 10.2992C5.25482 10.2747 5.07616 10.1798 4.94713 10.0323C4.81811 9.88484 4.74768 9.69515 4.74922 9.49922V5.99922H1.24922C1.03705 5.99922 0.833562 5.91493 0.683533 5.7649C0.533504 5.61488 0.449219 5.41139 0.449219 5.19922C0.449219 4.79922 0.849219 4.49922 1.24922 4.49922H4.74922V0.999219Z" fill="#171717" fill-opacity="0.6"/>
                        </svg>
                    </button>
                </div>
                <button>Clear</button>
            </div> 
        </div>
        <div class="gray-line"></div>
        <div class="add-property-row short-description">
            <label class="add-property-label">Short Description</label>
            <textarea></textarea>
        </div>
        <div class="add-property-row">
            <label class="add-property-label">Min Characters</label>
            <div class="add-property-value">
                <input type="text" placeholder="0"/>
                <div style="display: flex;">
                    <button class="minut__btn">
                        <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 4.75C0.75 4.336 1.086 4 1.5 4H9.5C9.914 4 10.25 4.336 10.25 4.75C10.25 5.164 9.914 5.5 9.5 5.5H1.5C1.086 5.5 0.75 5.164 0.75 4.75Z" fill="#171717" fill-opacity="0.6"/>
                        </svg>
                    </button>
                    <button class="plus__btn">
                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.74922 0.999219C4.74922 0.599219 5.04922 0.199219 5.54922 0.199219C5.94922 0.199219 6.24922 0.599219 6.24922 0.999219V4.49922H9.74922C10.1492 4.49922 10.5492 4.79922 10.5492 5.29922C10.5492 5.69922 10.1492 5.99922 9.74922 5.99922H6.24922V9.49922C6.24922 9.89922 5.94922 10.2992 5.44922 10.2992C5.25482 10.2747 5.07616 10.1798 4.94713 10.0323C4.81811 9.88484 4.74768 9.69515 4.74922 9.49922V5.99922H1.24922C1.03705 5.99922 0.833562 5.91493 0.683533 5.7649C0.533504 5.61488 0.449219 5.41139 0.449219 5.19922C0.449219 4.79922 0.849219 4.49922 1.24922 4.49922H4.74922V0.999219Z" fill="#171717" fill-opacity="0.6"/>
                        </svg>
                    </button>
                </div>
                <button>Clear</button>
            </div> 
        </div>
        <div class="add-property-row">
            <label class="add-property-label">Max Characters</label>
            <div class="add-property-value">
                <input type="text" placeholder="0"/>
                <div style="display: flex;">
                    <button class="minut__btn">
                        <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 4.75C0.75 4.336 1.086 4 1.5 4H9.5C9.914 4 10.25 4.336 10.25 4.75C10.25 5.164 9.914 5.5 9.5 5.5H1.5C1.086 5.5 0.75 5.164 0.75 4.75Z" fill="#171717" fill-opacity="0.6"/>
                        </svg>
                    </button>
                    <button class="plus__btn">
                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.74922 0.999219C4.74922 0.599219 5.04922 0.199219 5.54922 0.199219C5.94922 0.199219 6.24922 0.599219 6.24922 0.999219V4.49922H9.74922C10.1492 4.49922 10.5492 4.79922 10.5492 5.29922C10.5492 5.69922 10.1492 5.99922 9.74922 5.99922H6.24922V9.49922C6.24922 9.89922 5.94922 10.2992 5.44922 10.2992C5.25482 10.2747 5.07616 10.1798 4.94713 10.0323C4.81811 9.88484 4.74768 9.69515 4.74922 9.49922V5.99922H1.24922C1.03705 5.99922 0.833562 5.91493 0.683533 5.7649C0.533504 5.61488 0.449219 5.41139 0.449219 5.19922C0.449219 4.79922 0.849219 4.49922 1.24922 4.49922H4.74922V0.999219Z" fill="#171717" fill-opacity="0.6"/>
                        </svg>
                    </button>
                </div>
                <button>Clear</button>
            </div> 
        </div>
        <div class="gray-line"></div>
        <div class="add-property-row">
            <label class="add-property-label">Divider</label>
            <div class="add-property-value yes-no-div">
                <button style="width: 50%; background-color: white; margin: 0.2rem;">{{'COMMON.YES' | translate}}</button>
                <button style="width: 50%;">{{'COMMON.NO' | translate}}</button>
            </div>  
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="save__btn" data-bs-dismiss="modal">
          {{ "COMMON.SAVE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
